module.exports = __webpack_public_path__ + "overview-a5b6df21/disabled_play-1de5f593db58548bb5c8b6cc0614118b.svg";